import { AssignStatus, AssignStatusFilter } from "@/enum/list.enum";

/**
 * Canonical "Assigned" tab status set for the list-detail Leads view (PREC-3541).
 *
 * DONE is folded in here — the separate "Done" tab was removed and its leads now live under
 * "Assigned" (so the Analytics `assignedLeads` KPI and this tab stop disagreeing by the count of
 * done leads). The tab **count** (backend `LIST_DETAIL_ASSIGNED_STATUSES` in
 * apps/api/src/enums/list.enum.ts) and these row/filter/download sets must list the SAME statuses,
 * or the badge and the table disagree.
 */
export const ASSIGNED_TAB_STATUSES: AssignStatus[] = [
	AssignStatus.ASSIGNED,
	AssignStatus.RUNNING,
	AssignStatus.ENDED,
	AssignStatus.PAUSED,
	AssignStatus.NOT_NOW,
	AssignStatus.NO_REPLY,
	AssignStatus.REPLIES,
	AssignStatus.TO_BE_NURTURED,
	AssignStatus.DO_NOT_CONTACT,
	AssignStatus.MESSAGE_SENT,
	AssignStatus.DONE,
];

/**
 * Same set typed as {@link AssignStatusFilter} (identical string values) for the filter-typed
 * consumers (tab → assign-status-filter map, open-in-review scope).
 */
export const ASSIGNED_TAB_ASSIGN_STATUS_FILTERS: AssignStatusFilter[] =
	ASSIGNED_TAB_STATUSES as unknown as AssignStatusFilter[];
